<template>
  <main v-if="$page" id="main">
    <FaqSection :content="$page.faq" />
  </main>
</template>

<script>
import FaqSection from '@/components/sections/FaqSection.vue'
import Loader from '@/components/small/Loader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin'

export default {
  name: 'Faq',
  beetPage: 'home',
  inject: ['mq'],
  mixins: [PageMetaMixin],
  components: {
    Loader,
    FaqSection,
  },
}
</script>
